import { API_ENDPOINTS } from "@utils/api/endpoints";
import { useCategoryStore } from '@stores/category';

export default async function (force = false) {
  const store = useCategoryStore();
  const routeLang = useRouteLang();

  if (!store?.catalogue?.length || force) {
    const { data, error, status } = await useApiFetch(API_ENDPOINTS.CATALOGUE_CATEGORY, {
      key: `catalogue-categories-${routeLang.locale.value}`,
      params: {
        locale: routeLang.locale.value
      }
    });

    if (status.value === 'error') {
      sentryCaptureEvent({
        message: 'load-catalogue-categories',
        level: 'error',
        extra: { error: error.value }
      });
    } else {
      store.setCatalogue(data.value);
    }
  }
}
